<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title i18n="@@settings.localization.title">Localization</mat-panel-title>
  </mat-expansion-panel-header>
  <p i18n="@@settings.localization.description">Select which UI languages are available. If two or more are selected, a language switcher appears in the header.</p>
  <div class="language-list">
    @for (lang of availableLanguages; track lang.code) {
      <mat-checkbox
        [checked]="isEnabled(lang.code)"
        [disabled]="isDisabled(lang.code)"
        (change)="onToggle(lang.code, $event.checked)">
        {{ lang.nativeName }}
      </mat-checkbox>
    }
  </div>
</mat-expansion-panel>
